import matchHeight from 'jquery-match-height';

jQuery(document).ready(function($) {

  $('a[href^="#"]').on('click', function () {
    const speed = 500;
    const easing = 'swing';
    const href = $(this).attr('href');
    const target = $(href == '#' || href == '' ? 'html' : href);
    const spt = parseInt($('html').css('scrollPaddingTop')) || 0;
    const smt = parseInt($(target).css('scrollMarginTop')) || 0;
    // スクロール先
    const position = target.offset().top - (spt + smt);
    $('html, body').animate({ scrollTop: position }, speed, easing);
    // SPメニューの内部リンクの場合 ナビゲーションを閉じる
    if($(this).hasClass('js-nav-link')) {
      $(".js-nav-content.is-navOn, .js-nav-logo.is-navOn, .js-nav-bt.is-navOn").removeClass('is-navOn');
    }
    return false;
  });

  // SP nav
  $(document).ready(function () {
    $('.js-nav-bt').on('click', function () {
      if ($('.js-nav-content').hasClass('is-navOn')) {
        $(".js-nav-content").removeClass('is-navOn');
        $(".js-nav-logo").removeClass('is-navOn');
        $(this).removeClass('is-navOn');
      } else {
        $(".js-nav-content").addClass('is-navOn');
        $(".js-nav-logo").addClass('is-navOn');
        $(this).addClass('is-navOn');
      }
    });
    $('.js-nav-bt.is-navOn, .js-nav-logo.is-navOn').on('click', function () {
      $(".js-nav-content.is-navOn, .js-nav-logo.is-navOn, .js-nav-bt.is-navOn").removeClass('is-navOn');
    });
  });

  // ヘッダーの表示切り替え
  $(function () {
    $(window).on("load scroll", function () {
      const sliderHeight = $(".homeMv, .lowerMv").height();
      const originalHeaderHeight = 145; // 固定値を使用
      const delayOffset = 200; // 遅延オフセット（px）
      const threshold = sliderHeight - originalHeaderHeight + delayOffset;
      
      if ($(this).scrollTop() > threshold) {
        $(".js-header,.js-cv").addClass("is-headerOn");
      } else {
        $(".js-header,.js-cv").removeClass("is-headerOn");
      }
    });
  });


  if (window.matchMedia("(max-width: 768px)").matches) {

    $(function () {
      $(window).on("scroll", function () {
        const scrollHeight = $(document).height();
        const scrollPosition = $(window).height() + $(window).scrollTop();
        const footHeight = $(".js-footer-sp").innerHeight();
        if (scrollHeight - scrollPosition <= footHeight) {
          $(".js-cv-sp").addClass("is-none");
        } else {
          $(".js-cv-sp").removeClass("is-none");
        }
      });
    });

    jQuery(function($) {
      if (matchMedia("(max-width: 768px)").matches) {
        $('.js-sp-navDown').on('click', function (e) {
          e.preventDefault();
          // SP用のメニュー（.js-sp-subLink）を展開
          $(this).siblings('.js-sp-subLink').slideToggle();
          $(this).toggleClass('is-on');
        });
      }
    });
  }

  $(function () {
    const fade_bottom = 200; // 画面下からどの位置でフェードさせるか(px)
    const fade_move = 100; // どのぐらい要素を動かすか(px)
    const fade_time = 800; // フェードの時間(ms)
    // フェード前のcssを定義
    $(".scroll-fade-up").css({
      opacity: 0,
      transform: "translateY(" + fade_move + "px)",
      transition: fade_time + "ms",
    });
    // スクロールまたはロードするたびに実行
    $(window).on("scroll load", function () {
      const scroll_top = $(this).scrollTop();
      const scroll_bottom = scroll_top + $(this).height();
      const fade_position = scroll_bottom - fade_bottom;
      $(".scroll-fade-up").each(function () {
        const this_position = $(this).offset().top;
        if (fade_position > this_position) {
          $(this).css({
            opacity: 1,
            transform: "translateY(0)",
          });
        }
      });
    });
  });

  $('.js-matchHeight').matchHeight();
  $('.js-matchHeight2').matchHeight();

  // ウィンドウリサイズ時の再計算
  $(window).on('resize', function() {
    $.fn.matchHeight._update();
  });


});
